import { FulfillmentOrderProcessingRouteService } from 'common/data';
import { BaseService } from 'core/services';

class FulfillmentOrderProcessingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderProcessingRouteService());
	}

	createFulfillmentShipment = (id, sourceOfChange, updateAndCreatePrintJob) => {
		const url = this.routeService.createFulfillmentShipment(id, sourceOfChange, updateAndCreatePrintJob);
		return this.apiClient.get(url);
	};

	createFulfillmentShipmentBulk = (params, sourceOfChange, updateAndCreatePrintJob) => {
		const url = this.routeService.createFulfillmentShipmentBulk(sourceOfChange, updateAndCreatePrintJob);
		return this.apiClient.post(url, { fulfillmentOrderIds: params.fulfillmentOrderIds });
	};
}

export default FulfillmentOrderProcessingService;



// WEBPACK FOOTER //
// ./src/common/data/services/FulfillmentOrderProcessingService.js